import _ from 'lodash';
/**
 * name: The name of the property defined in JIRA seen when requesting getProcurementRequestIssueType / getRipProjectFieldsMeta
 * validationType: The field type. If the field is going to be validated by yup schemas, this property should equal a valid yup type
 * validations: an array of additional validations for the field. If using yup to validate the model, use validations supported by yup
 */

const ApplicantModel = _.mapValues(
  {
    name: {
      name: 'Name',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'max',
          params: [50, 'Max size is 50 characters'],
        },
      ],
    },
    company: {
      name: 'Company',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'max',
          params: [50, 'Max size is 50 characters'],
        },
      ],
    },
    comment: {
      name: 'Comment',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'max',
          params: [5000, 'Max size is 5000 characters'],
        },
      ],
    },
    attachment: {
      name: 'Attachment',
      validationType: 'array',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'min',
          params: [1, ''],
        },
      ],
    },
  },
  (value, key) => ({
    aliasName: value.name,
    ...value,
    id: key,
  })
);

export default ApplicantModel;
